import React from 'react';
import PropTypes from 'prop-types';
import styles from '../../styles/scss/components/industrial/numbered-steps-list.module.scss';
import NumberedStepsItem from './NumberedStepsItem';

const NumberedStepsList = ({ data }) => {
  const { eyebrow, title, subtitle, body, steps } = data;
  
  return (
    <section className={styles.container}>
      <div className={styles.content}>
        <div className={styles.header}>
          {eyebrow && <p className={styles.eyebrow}>{eyebrow}</p>}
          {title && <h2 className={styles.title}>{title}</h2>}
          {subtitle && <h3 className={styles.subtitle}>{subtitle}</h3>}
          {body && <p className={styles.body}>{body}</p>}
        </div>
        
        <div className={styles.stepsContainer}>
          {steps && steps.map((step, index) => (
            <NumberedStepsItem 
              key={index}
              number={index + 1}
              title={step.title}
              description={step.description}
              bulletPoints={step.bulletPoints}
              position={index % 2 === 0 ? 'left' : 'right'}
              isLast={index === steps.length - 1}
            />
          ))}
        </div>
      </div>
    </section>
  );
};

NumberedStepsList.propTypes = {
  data: PropTypes.shape({
    eyebrow: PropTypes.string,
    title: PropTypes.string.isRequired,
    subtitle: PropTypes.string,
    body: PropTypes.string,
    backgroundColor: PropTypes.oneOf(['blue', 'white', 'gray']),
    steps: PropTypes.arrayOf(
      PropTypes.shape({
        number: PropTypes.string.isRequired,
        title: PropTypes.string.isRequired,
        description: PropTypes.string,
        bulletPoints: PropTypes.arrayOf(
          PropTypes.shape({
            title: PropTypes.string,
            description: PropTypes.string
          })
        )
      })
    ).isRequired
  }).isRequired
};

export default NumberedStepsList;
